module.exports = __webpack_public_path__ + "img/lobster.a4f892c8.svg";